import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { BASE_URL } from "../utils/config";

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();
  }, [user]);

  const checkAdminStatus = async () => {
    if (!user || !user.token) {
      setLoading(false);
      setIsAdmin(false);
      return;
    }

    // First check if role is already in user object (from login response)
    if (user.role === 'admin') {
      setIsAdmin(true);
      setLoading(false);
      return;
    }

    // Check localStorage as fallback
    try {
      const storedUserStr = localStorage.getItem("user");
      if (storedUserStr) {
        const storedUser = JSON.parse(storedUserStr);
        if (storedUser && storedUser.role === 'admin') {
          setIsAdmin(true);
          setLoading(false);
          return;
        }
      }
    } catch (e) {
      console.log("Error reading localStorage:", e);
    }

    // If role not found, try to fetch from backend
    try {
      const res = await fetch(`${BASE_URL}/users/${user.id}`, {
        headers: {
          "Authorization": user.token,
        },
      });

      if (res.ok) {
        const responseData = await res.json();
        const userData = responseData?.data || responseData;
        
        if (userData && userData.role === "admin") {
          setIsAdmin(true);
          // Update user object and localStorage with role
          const updatedUser = { ...user, role: 'admin' };
          localStorage.setItem("user", JSON.stringify(updatedUser));
        } else {
          setIsAdmin(false);
        }
      } else {
        // Backend failed - deny access
        setIsAdmin(false);
      }
    } catch (error) {
      console.error("Error checking admin status:", error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loader"></div>
        <p>Checking access...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        minHeight: "100vh",
        flexDirection: "column",
        gap: "1rem"
      }}>
        <h2>Access Denied</h2>
        <p>You need admin privileges to access this page.</p>
        <a href="/admin/login" style={{ color: "var(--secondary-color)" }}>Go to Login</a>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;

